import React from 'react';
import './Logo.css';

type LogoProps = {
  /** Height of the logo in pixels. Font sizing is derived from this. */
  height?: number;
  /** Render the Amharic "ሎሚ" next to the English wordmark. */
  withAmharic?: boolean;
  /** Dark surface? Flips the wordmark color to the light variant. */
  variant?: 'light' | 'dark';
  className?: string;
  onClick?: () => void;
};

/**
 * Composite Lomi wordmark: branded lemon mark + styled "Lomi" text, with
 * optional Amharic ሎሚ pairing. The icon is the shared PNG from public/ so
 * it stays in sync with favicon/PWA/apple-touch assets; the wordmark is
 * live HTML text so it remains crisp and theme-recolorable.
 */
const Logo: React.FC<LogoProps> = ({
  height = 32,
  withAmharic = false,
  variant = 'light',
  className = '',
  onClick,
}) => {
  const fontSize = Math.round(height * 0.72);
  const iconSize = Math.round(height * 1.1);
  return (
    <span
      className={`lomi-logo lomi-logo--${variant} ${className}`.trim()}
      style={{ fontSize: `${fontSize}px`, lineHeight: 1 }}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
    >
      <img
        src="/logo192.png"
        alt=""
        aria-hidden="true"
        className="lomi-logo__icon"
        width={iconSize}
        height={iconSize}
      />
      <span className="lomi-logo__name">Lomi</span>
      {withAmharic && <span className="lomi-logo__amharic">ሎሚ</span>}
    </span>
  );
};

export default Logo;
